<template>
  <div class="media-container">
    <media-image
      ref="image"
      v-if="showImage"
      :keyPost="keyPost"
      :mediaSource="mediaSource"
      :size="mediaFormat"
      :classArray="['image', mediaClassFormat]"
    />
    <Video
      ref="video"
      v-if="showVideo"
      :keyPost="keyPost"
      :mediaSource="mediaSource"
      :size="mediaFormat"
      :index="index"
      :classArray="['video', mediaClassFormat]"
    />
    <div
      ref="space"
      v-if="showNone"
      class="showNoneMedia"
      :keyPost="keyPost"
      :index="index"
      :style="mediaFormatStyle"
    >
      <v-icon large>mdi-image-search-outline</v-icon>
    </div>
  </div>
</template>

<script>
import MediaImage from './image'
import Video from './video'
export default {
  name: 'Media',
  props: {
    mediaSource: Object,
    type: String,
    size: Number,
    keyPost: String,
    index: Number,
    isVisible: Boolean
  },
  created () {
    window.addEventListener('resize', this.resizeHandler)
  },
  destroyed () {
    window.removeEventListener('resize', this.resizeHandler)
  },
  components: {
    MediaImage,
    Video
  },
  data () {
    return {
      height: 0,
      width: 0
    }
  },
  computed: {
    mediaFormat: function () {
      return this.mediaSource.format === 'original' ? 0 : this.width
    },
    mediaClassFormat: function () {
      return this.mediaSource.format === 'original' ? '' : 'square'
    },
    showImage: function () {
      return this.isVisible && this.type === 'image'
    },
    showVideo: function () {
      return this.isVisible && this.type === 'video'
    },
    showNone: function () {
      return !this.isVisible
    },
    mediaFormatStyle: function () {
      let style = {
        width: this.width + 'px'
      }
      style.height =
        this.mediaClassFormat === 'square'
          ? this.width + 'px'
          : this.height + 'px'
      return style
    }
  },
  methods: {
    resizeHandler (e) {
      this.height = window.innerWidth
      this.width = window.innerWidth
    }
  },
  mounted () {
    this.height = window.innerHeight
    this.width = window.innerWidth
  }
}
</script>



// WEBPACK FOOTER //
// src/components/media/index.vue